import { Suspense } from 'react';

import { VideoPlayer } from '@/shared/components/atoms';

const VectorContainer = () => {
  return (
    <div className='relative hidden h-full w-full tablet:block'>
      <div className='flex h-screen items-center justify-center overflow-hidden bg-background-400'>
        <Suspense fallback={<p>Loading video...</p>}>
          <VideoPlayer
            src='/videos/signup_video.hevc.mp4'
            type='video/mp4'
            poster='images/login/farm.jpg'
            autoplay
            controls={false}
            loop
          />
        </Suspense>
      </div>
    </div>
  );
};

export { VectorContainer };
